



































import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    computed: mapGetters('esb', { getMod: 'get' }),
    methods: mapActions('bh-flow', ['setSettings'])
})
export default class BHFlowGenerator extends Vue {
    @Prop({ default() { return []; } })
    value!: any[];

    @Prop({ default() { return []; } })
    info!: any[];

    @Prop({ default: false })
    noFirst!: boolean;

    @Prop({ default: false })
    nativeParent!: boolean;

    @Prop({ default: false })
    root!: boolean;

    @Prop({ default: () => null })
    eventHandler!: Function;

    setSettings: any;

    public onDropItem(info: any, data: any) {
        this.$emit('drop', {
            info: [...this.info, ...(data.info || info)],
            ...data
        });
    }

    public onSave(mod: any, data: any) {
        mod.props = data;
    }

    public onItemClick(mod: any) {
        this.setSettings({
            ...mod,
            handler: this.onSave.bind(this, mod)
        });
    }
}
